import React, { createContext, useContext, useState } from 'react';

const PubSubContext = createContext();

export const PubSubProvider = ({ children }) => {
    const [subscribers, setSubscribers] = useState([]);

    const subscribe = (event, callback) => {
        setSubscribers((prev) => [...prev, { event, callback }]);
    };

    const unSubscribe = (event) => {
        setSubscribers((prev) => [...prev.filter(s => s.event !== event)]);
    }

    const publish = (event, data) => {
        const pubEvent = subscribers.find(s => s.event === event);
        console.log('subs', subscribers);

        if (pubEvent?.callback && typeof (pubEvent.callback) == 'function')
            pubEvent.callback(data);
    };

    return (
        <PubSubContext.Provider value={{ subscribe, publish, unSubscribe }}>
            {children}
        </PubSubContext.Provider>
    );
};

export const usePubSub = () => useContext(PubSubContext);
